import { useTranslation } from "react-i18next";
import type { PendingToolApproval } from "../../../api/threads/liveMessages";
import { useApprovalTarget } from "../entries/useApprovalPage";

/** The listing supplies waiting tools; the Thread remains the place to answer them. */
export default function ToolApprovalInboxHint({ approvals, connectorId }: { approvals: readonly PendingToolApproval[]; connectorId: string | null }) {
  const { t } = useTranslation();
  const target = useApprovalTarget(connectorId);
  return <>{approvals.map((approval) => (
    <span key={approval.request_id} className="app-text-muted block pl-3.5 text-xs">
      {t("threads.inbox.toolEffect", { tool: approval.tool.tool_name, pc: target?.pc ?? t("threads.toolApproval.hostPc") })}
    </span>
  ))}</>;
}
